<script>
  import Button from '../assets/general/button.svelte';
  
  // State for the iframe source
  let liveVideoSrc = "8Cxqy0bY1KI";

  // Function to update the video source
  function updateVideo(src) {
    liveVideoSrc = src;
  }
</script>

<div class="video-buttons">
  <button on:click={() => updateVideo("8Cxqy0bY1KI")}>9am</button>
  <button on:click={() => updateVideo("k2NquN60KAI")}>4pm</button>
</div>

<div class="live-container">
  <div class="live-video">
    <iframe id="liveVideoIframe" src="https://www.youtube.com/embed/{liveVideoSrc}" frameborder="0" allowfullscreen></iframe>
  </div>
  <div class="donate-button-container">
  <Button
  link="https://secure.givelively.org/donate/freedom-writers-foundation/giving-tuesday-30-for-30-campaign"
  text="DONATE NOW"
  />
  </div>
</div>

<style>
  .live-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: start;
      height: auto;
      padding: 20px;
  }
  .live-video {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    /* Optional: set a specific width if needed */
    /* width: 600px; */
  }
  iframe {
      width: 100%;
      border: none;
  }
  #liveVideoIframe {
      height: 500px;
      width: calc(500px * 16 / 9);
  }
  .donate-button-container {
      width: 100%;
      text-align: center;
      padding-top: 20px;
  }
  .video-buttons {
      text-align: center;
      margin: 20px 0;
  }
  .video-buttons button {
      background-color: #f7931e;
      color: white;
      border: none;
      border-radius: 10px;
      padding: 10px 20px;
      margin: 0 10px;
      font-family: 'Oswald', sans-serif;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;
  }
  .video-buttons button:hover {
      background-color: #e67e22;
  }
</style>